
export const VIEW_PERMISSIONS = [
  { key: 'view.home', label: 'Accueil', path: '/dashboard/home' },
  { key: 'view.organizations', label: 'Clients', path: '/dashboard/organizations' },
  { key: 'view.organizations.portfolio', label: 'Portefeuille client', path: '/dashboard/organizations/portfolio' },
  { key: 'view.organizations.users', label: 'Utilisateurs client', path: '/dashboard/organizations/users' },
  { key: 'view.quotes', label: 'Devis', path: '/dashboard/quotes' },
  { key: 'view.contracts', label: 'Contrats', path: '/dashboard/contrats' },
  { key: 'view.contracts.annual', label: 'Contrats annuel', path: '/dashboard/contrats/annual' },
  { key: 'view.contracts.monthly', label: 'Contrats mensuel', path: '/dashboard/contrats/monthly' },
  { key: 'view.contracts.list', label: 'Liste contrats', path: '/dashboard/contrats/list' },
  { key: 'view.contracts.matrix', label: 'Matrice contrats', path: '/dashboard/contrats/matrix' },
  { key: 'view.tickets', label: 'Tickets', path: '/dashboard/tickets' },
  { key: 'view.tickets.time', label: 'Temps passes', path: '/dashboard/tickets/timeEntry' },
  { key: 'view.tickets.ik', label: 'IK global', path: '/dashboard/tickets/ik' },
  { key: 'view.tickets.myik', label: 'Mes IK', path: '/dashboard/tickets/myik' },
  { key: 'view.history', label: 'Historique', path: '/dashboard/history' },
  { key: 'view.domains', label: 'Noms de domaine', path: '/dashboard/domain' },
  { key: 'view.centreon', label: 'Centreon', path: '/dashboard/centreon' },
  { key: 'view.o365', label: 'O365 general', path: '/dashboard/o365' },
  { key: 'view.o365.licenses', label: 'O365 licences', path: '/dashboard/o365/licenses' },
  { key: 'view.o365.users', label: 'O365 utilisateurs', path: '/dashboard/o365/users' },
  { key: 'view.vbo365', label: 'Veeam Backup O365', path: '/dashboard/vbo365' },
  { key: 'view.vbo365.licenses', label: 'VBO365 licences', path: '/dashboard/vbo365/licenses' },
  { key: 'view.vbo365.users', label: 'VBO365 utilisateurs', path: '/dashboard/vbo365/users' },
  { key: 'view.eset', label: 'ESET general', path: '/dashboard/eset' },
  { key: 'view.eset.licenses', label: 'ESET licences', path: '/dashboard/eset/licenses' },
  { key: 'view.eset.devices', label: 'ESET appareils', path: '/dashboard/eset/devices' },
  { key: 'view.level', label: 'Level.io', path: '/dashboard/level' },
  { key: 'view.level.devices', label: 'Level.io devices', path: '/dashboard/level/devices' },
  { key: 'view.signitic', label: 'Signitic', path: '/dashboard/signitic' },
  { key: 'view.mc3.products', label: 'MC3 produits', path: '/dashboard/mc3cloud/products' },
  { key: 'view.import', label: 'Imports', path: '/dashboard/import' },
  { key: 'view.products', label: 'Produits', path: '/dashboard/products' },
  { key: 'view.reports', label: 'Rapports', path: '/dashboard/reports' },
  { key: 'view.invoices', label: 'Factures', path: '/dashboard/factures' },
  { key: 'view.settings', label: 'Paramètres', path: '/dashboard/settings' },
  { key: 'view.permissions', label: 'Permissions', path: '/dashboard/settings/permissions' },
];

export const ACTION_PERMISSIONS = [
  { key: 'action.organizations.write', label: 'Modifier les clients' },
  { key: 'action.quotes.write', label: 'Creer / modifier les devis' },
  { key: 'action.contracts.write', label: 'Creer / modifier les contrats' },
  { key: 'action.contracts.matrix.write', label: 'Modifier les matrices contrats' },
  { key: 'action.products.write', label: 'Creer / modifier les produits' },
  { key: 'action.invoices.write', label: 'Creer / modifier les factures' },
  { key: 'action.o365.sync', label: 'Synchroniser O365' },
  { key: 'action.eset.sync', label: 'Synchroniser ESET' },
  { key: 'action.signitic.write', label: 'Modifier Signitic' },
  { key: 'action.users.write', label: 'Creer / modifier les utilisateurs' },
  { key: 'action.settings.manage', label: 'Gerer les paramètres' },
  { key: 'action.permissions.manage', label: 'Gerer les permissions' },
];

export const isAdminRole = (user) => String(user?.role || '').toLowerCase() === 'admin';
export const hasPermission = (user, permissionKey) => isAdminRole(user) || (user?.permissions || []).includes(permissionKey);
export const filterAllowedItems = (items = [], user) => items
  .map((item) => {
    if (item.section) return item;
    const subItems = Array.isArray(item.subItems) ? filterAllowedItems(item.subItems, user) : null;
    const allowed = !item.permission || hasPermission(user, item.permission);
    if (!allowed && (!subItems || subItems.length === 0)) return null;
    return { ...item, ...(subItems ? { subItems } : {}) };
  })
  .filter(Boolean)
  .filter((item, index, arr) => !item.section || (arr[index + 1] && !arr[index + 1].section));
